export const SET_LEVELS_LIST = 'levels/SET_LEVELS_LIST'
export const SET_ACHIEVEMENTS_LIST = 'achievements/SET_ACHIEVEMENTS_LIST'
export const SET_PLAYERS_LIST = 'players/SET_PLAYERS_LIST'
export const SET_PLAYER_PROFILE = 'players/SET_PLAYER_PROFILE'
